/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.sales.documents.rpc.SalesDocumentsPublicSharedLinkService
 */
import * as References from './SalesDocumentsPublicSharedLinkService';
import { createRpcClientV2 } from 'rpc-client-utils';
import noAuthHttp from 'hub-http/clients/noAuthApiClient';
import { registerQuery } from 'data-fetching-client/next';
export const chirpClient = createRpcClientV2({
  hubHttpClient: noAuthHttp
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.sales.documents.rpc.SalesDocumentsPublicSharedLinkService#getPublicSharedLink
 */
export const GET_PUBLIC_SHARED_LINK_QUERY_FIELD_NAME = 'com_hubspot_sales_documents_rpc_SalesDocumentsPublicSharedLinkService_getPublicSharedLink';
export const GET_PUBLIC_SHARED_LINK_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PUBLIC_SHARED_LINK_QUERY_FIELD_NAME,
  args: ['sharedLinkId', 'accessId'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getPublicSharedLinkRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.sales.documents.rpc.SalesDocumentsPublicSharedLinkService#getPublicSharedLinkDownloadUrl
 */
export const GET_PUBLIC_SHARED_LINK_DOWNLOAD_URL_QUERY_FIELD_NAME = 'com_hubspot_sales_documents_rpc_SalesDocumentsPublicSharedLinkService_getPublicSharedLinkDownloadUrl';
export const GET_PUBLIC_SHARED_LINK_DOWNLOAD_URL_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PUBLIC_SHARED_LINK_DOWNLOAD_URL_QUERY_FIELD_NAME,
  args: ['sharedLinkId', 'accessId'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.getPublicSharedLinkDownloadUrlRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.sales.documents.rpc.SalesDocumentsPublicSharedLinkService#getPublicFeatures
 */
export const GET_PUBLIC_FEATURES_QUERY_FIELD_NAME = 'com_hubspot_sales_documents_rpc_SalesDocumentsPublicSharedLinkService_getPublicFeatures';
export const GET_PUBLIC_FEATURES_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PUBLIC_FEATURES_QUERY_FIELD_NAME,
  args: ['hubPortalId'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.getPublicFeaturesRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});